// extracted by mini-css-extract-plugin
module.exports = {"heading":"xeagO","tabContainer":"SIyyH","tabWrapper":"_1rpjP","activeTab":"_1jTmK","viewAllCars":"gJ2m8","sliderWrapper":"_1DO27"};